import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import AddParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Types';
import NoParticipants from './NoParticipants';
import Participants from './Participants';

export interface Props {
  store: AddParticipantStore;
  state: SelectParticipantsState;
}

function ParticipantsList({ store, state }: Props) {
  return fromEmpty([...state.newGroupsAndParticipants])
    .map(() => <Participants store={store} state={state} />)
    .getOrElse(() => <NoParticipants submit={store.submit} />);
}

export default observer(ParticipantsList);
